@for (rating of ratings(); track $index) {
    <sirius-rating-item [label]="rating.label" [value]="rating.value" [max]="max()"></sirius-rating-item>
}
